import './BetbookPosts.less';

import React from 'react';
import PopupNg from '@/ui/PopupNg';
import i18n from 'nike-ui/src/common/i18n';
import { useReframe } from 'nike-re-framejs';
import { useActiveRoute } from 'nike-ui/src/common/routing/NikeRouteContext';

import Button from '@/common/component/Button';
import ArrowDownIcon from '@/icons/ArrowDownIcon';
import BetbookFilterButton from 'nike-ui/src/components/betbook/betbookFilters/BetbookFilterButton';

import { BETTABLE, POST_BLOG, TIME_3HOURS, TIME_TODAY, TIME_TOMORROW } from 'nike-ui/src/components/betbook/constants';
import { COMMUNITY_POSTS_AUTHOR } from '@/routing/routes';

import { filterSorting$ } from '@/betbook/subs';
import {
    betbookFilterBetCount$,
    betbookFilterExpirationTag$,
    betbookFilterOdds$,
    betbookFilterSportIds$,
    betbookFilterStake$,
    betbookFilterWin$
} from 'nike-ui/src/components/betbook/subs';
import { fetchBetbookFilterConfig } from 'nike-ui/src/components/betbook/handlers';

function getAppliedFilters(betCount, expirationTag, odds, sportIds, stake, win) {
    let filtersCount = 0;

    if (expirationTag === TIME_3HOURS || expirationTag === TIME_TODAY || expirationTag === TIME_TOMORROW) {
        filtersCount += 1;
    }
    if (expirationTag === BETTABLE) {
        filtersCount += 1;
    }
    if (sportIds) {
        sportIds.forEach(() => (filtersCount += 1));
    }
    if (odds) {
        const [min, max] = odds;
        filtersCount += min || max ? 1 : 0;
    }
    if (stake) {
        const [min, max] = stake;
        filtersCount += min || max ? 1 : 0;
    }
    if (win) {
        const [min, max] = win;
        filtersCount += min || max ? 1 : 0;
    }
    if (betCount) {
        const [min, max] = betCount;
        filtersCount += min || max ? 1 : 0;
    }
    return filtersCount;
}

function BetbookFilters({ postType }) {
    const { subscribe } = useReframe();
    const route = useActiveRoute();
    const sorting = subscribe(filterSorting$);
    const hideExtendedFilterButton = route === COMMUNITY_POSTS_AUTHOR || postType === POST_BLOG;
    const appliedBetCount = subscribe(betbookFilterBetCount$);
    const appliedExpirationTag = subscribe(betbookFilterExpirationTag$);
    const appliedOdds = subscribe(betbookFilterOdds$);
    const appliedSportIds = subscribe(betbookFilterSportIds$);
    const appliedStake = subscribe(betbookFilterStake$);
    const appliedWin = subscribe(betbookFilterWin$);
    const appliedFilters = getAppliedFilters(
        appliedBetCount,
        appliedExpirationTag,
        appliedOdds,
        appliedSportIds,
        appliedStake,
        appliedWin
    );

    const postTypeTitle = {
        ANALYSIS: i18n('betbook.dropdown.ANALYSIS'),
        TICKET: i18n('betbook.dropdown.TICKET'),
        BLOG: i18n('betbook.dropdown.BLOG'),
        undefined: i18n('betbook.dropdown.ANALYSIS')
    };

    const sortingTitle = {
        RECOMMENDED: i18n('betbook.sorting.RECOMMENDED'),
        NEWEST: i18n('betbook.dropdown.NEWEST'),
        TOP: i18n('betbook.dropdown.TOP'),
        INSPIRATIONS: i18n('betbook.dropdown.INSPIRATIONS'),
        VIEWS: i18n('betbook.dropdown.VIEWS'),
        COMMENTS: i18n('betbook.dropdown.COMMENTS'),
        undefined: i18n('betbook.dropdown.NEWEST')
    };

    function openFilterDialog(e) {
        const dialogOpenKey = e.currentTarget.value;
        if (dialogOpenKey === 'extendedFilterDialog') {
            fetchBetbookFilterConfig(postType);
        }
        PopupNg.dispatcher.open('betbook/postsDialog', { dialogOpenKey, postType });
    }

    return (
        <div className="default-sub-slider hide-mz-scrollbar betbook-slider-no-bg flex px-20 pt-30">
            {route === COMMUNITY_POSTS_AUTHOR ? (
                <Button
                    className="betbook-dropdown-button active br-default"
                    onClick={openFilterDialog}
                    value="postTypeDialog"
                    data-atid="betbook-filter-postType"
                >
                    {postTypeTitle[postType]}
                    <div className="arrow-down">
                        <ArrowDownIcon />
                    </div>
                </Button>
            ) : null}
            <Button
                className="betbook-dropdown-button br-default"
                onClick={openFilterDialog}
                value="sortingDialog"
                data-atid="betbook-filter-sorting"
            >
                {sortingTitle[sorting]}
                <div className="arrow-down">
                    <ArrowDownIcon className="arrow-down" />
                </div>
            </Button>
            {hideExtendedFilterButton ? null : (
                <BetbookFilterButton
                    active={appliedFilters > 0}
                    onClick={openFilterDialog}
                    resultsCount={appliedFilters}
                    value="extendedFilterDialog"
                />
            )}
        </div>
    );
}

export default BetbookFilters;
